enum ContactEmails {
  CUSTOMER_SERVICE_EMAIL= 'customerservice@auction.com', // To be used in error pages in ADC
  SMART_SALE_CONCIERGE = 'PrivateSellerTeam@auction.com',
}

export default ContactEmails
